import { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from 'react-google-recaptcha';
import '../css/ContactForm.css';
import '../css/common.css';

const ContactForm = (props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [stateMessage, setStateMessage] = useState(null);
    const refCaptcha = useRef(null);

    const lang = props.lang;

    const labels = {
        name:    lang === 'en' ? 'From'    : 'De',
        send:    lang === 'en' ? 'Send'    : 'Enviar',
        message: lang === 'en' ? 'Message' : 'Mensaje',
        ok:      lang === 'en' ? 'Message sent.'              : 'Mensaje enviado.',
        fail:    lang === 'en' ? 'Something failed. Try again.' : 'Algo falló. Intente nuevamente.',
    };

    const sendEmail = (e) => {
        e.preventDefault();

        const token = refCaptcha.current.getValue();
        if (!token) {
            setStateMessage(lang === 'en' ? 'Please complete the captcha.' : 'Por favor completa el captcha.');
            return;
        }

        setIsSubmitting(true);

        const formData = new FormData(e.target);
        const params = {
            from_name: formData.get('from_name'),
            email:     formData.get('email'),
            message:   formData.get('message'),
            'g-recaptcha-response': token,
        };

        emailjs.send(
            process.env.REACT_APP_SERVICE_ID,
            process.env.REACT_APP_TEMPLATE_ID,
            params,
            process.env.REACT_APP_PUBLIC_KEY
        )
        .then(() => {
            setStateMessage(labels.ok);
            setIsSubmitting(false);
            refCaptcha.current.reset();
            e.target.reset();
            setTimeout(() => setStateMessage(null), 5000);
        })
        .catch((err) => {
            console.error('EmailJS error:', err);
            setStateMessage(labels.fail);
            setIsSubmitting(false);
            setTimeout(() => setStateMessage(null), 5000);
        });
    };

    return (
        <div className='medDiv'>
            <article className='article' name='contact-form'>
                <form onSubmit={sendEmail}>
                    <div className='jobliner-container'>
                        <div className='jobliner-icon'>{labels.name}<br/>Email</div>
                        <div className='spacer-1'></div>
                        <div className='jobliner-data'>
                            <input type='text' name='from_name' className='input-data' pattern='[A-Za-z ]{1,100}'/>
                            <br/>
                            <input type='email' name='email' className='input-data'/>
                        </div>
                    </div>
                    <label>{labels.message}</label>
                    <div className='jobliner-container'>
                        <br/>
                        <textarea name='message'/>
                    </div>
                    <div>
                        <br/>
                        <div className='div-centered'>
                          <div className='col'  style={{paddingRight: '15px'}}>
                          <ReCAPTCHA
                              ref={refCaptcha}
                              sitekey={process.env.REACT_APP_GOOGLE_DATA_SITEKEY}
                          />
                          </div>
                          <div className='col' style={{paddingLeft: '15px'}}>
                            <input type='submit' value={labels.send} disabled={isSubmitting} className='send-button'/>
                            {stateMessage && <p>{stateMessage}</p>}
                          </div>
                        </div>
                    </div>
                </form>
            </article>
        </div>
    );
};

export default ContactForm;